module.exports = __webpack_public_path__ + "img/Loading.1c510045.svg";